/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarEventResponse } from '../../models/calendar-event-response';
import { EventUpdateRequest } from '../../models/event-update-request';

export interface PutFeV1EventsId$Plain$Params {

/**
 * The hashed event ID.
 */
  id: string;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;

/**
 * Unique identifier for tracing the request across services
 */
  'X-Correlation-Id'?: string;
  
    /**
     * Event update data.
     */
    body?: EventUpdateRequest
}

export function putFeV1EventsId$Plain(http: HttpClient, rootUrl: string, params: PutFeV1EventsId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEventResponse>> {
  const rb = new RequestBuilder(rootUrl, putFeV1EventsId$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.header('X-Correlation-Id', params['X-Correlation-Id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendarEventResponse>;
    })
  );
}

putFeV1EventsId$Plain.PATH = '/v1/events/{id}';
